import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useExamTemplateRequestSelector,
  useMasterSchoolYearsSelector,
  useMasterSubjectsSelector,
} from '../../../../redux/selector';
import { Input, message, Select } from 'antd';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../redux/store/store';
import {
  updateExamTemplatePartRequest,
  updateExamTemplateQuestionRequest,
  updateExamTemplateRequest,
} from '../../../../redux/slice/examTemplateEditSlice';
import Tree from 'component/common/Tree';
import { DeleteOutlined, LineOutlined, MinusSquareOutlined, PlusOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import { ExamTemplatePartRequest, ExamTemplateQuestionRequest } from 'model/request';
import { questionTypes } from 'common/data';
import { uuidv4 } from 'common/commonFunc';
import axiosInstance from '../../../../axios/axiosInstance';
import { QuestionType } from 'common/enum';
import processError from '../../../../utils/processError';

export default function EditExamTemplate() {
  const params = useParams();
  const examTemplateRequest = useExamTemplateRequestSelector();
  const schoolYearList = useMasterSchoolYearsSelector();
  const subjectList = useMasterSubjectsSelector();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const cancelForm = (e: any) => {
    navigate(-1);
  };

  const calculateHeight = () => {
    const editExamTemplate = document.querySelector('.edit-exam-template') as HTMLElement;
    const leftBox = editExamTemplate.querySelector('.left-box') as HTMLElement;
    const rightBox = editExamTemplate.querySelector('.right-box') as HTMLElement;

    leftBox.style.height = editExamTemplate.getBoundingClientRect().height - 105 + 'px';
    leftBox.classList.remove('hidden');

    rightBox.style.height = editExamTemplate.getBoundingClientRect().height - 105 + 'px';
    rightBox.classList.remove('hidden');
  };

  const onInput = (e: any, fieldName: string) => {
    const examTemplateRequestTemp = { ...examTemplateRequest } as any;
    examTemplateRequestTemp[fieldName] = e.target.value;

    dispatch(updateExamTemplateRequest(examTemplateRequestTemp));
  };

  const onInputExamTemplatePart = (e: any, examTemplatePart: ExamTemplatePartRequest, fieldName: string) => {
    const examTemplatePartTemp = { ...examTemplatePart } as any;
    examTemplatePartTemp[fieldName] = e.target.value;
    let examTemplateQuestionsTemp;
    if (fieldName === 'numberOfQuestions') {
      examTemplateQuestionsTemp = Array.from(
        Array(Number(e.target.value) > 0 ? Number(e.target.value) : 0),
        (_, index) => ({
          id: uuidv4(),
          name: `Câu ${Number(index) + 1}:`,
          code: '',
          description: '',
          questionIndex: index,
          defaultQuestionType: QuestionType.ONE_CHOICE_QUESTION,
          defaultMark: 1,
          defaultWeight: 1,
          numberOfQuestions: 0,
          examTemplatePart: {
            id: examTemplatePart.id,
          },
          examTemplateQuestions: [],
        }),
      );

      examTemplatePartTemp.examTemplateQuestions = examTemplateQuestionsTemp;
    }

    dispatch(updateExamTemplatePartRequest(examTemplatePartTemp));
  };

  const onInputExamTemplateQuestion = (
    e: any,
    examTemplateQuestion: ExamTemplateQuestionRequest,
    examTemplatePart: ExamTemplatePartRequest,
    fieldName: string,
  ) => {
    const examTemplateQuestionTemp = { ...examTemplateQuestion } as any;
    examTemplateQuestionTemp[fieldName] = e.target.value;

    let examTemplateQuestionsTemp;
    if (fieldName === 'numberOfQuestions') {
      examTemplateQuestionsTemp = Array.from(
        Array(Number(e.target.value) > 0 ? Number(e.target.value) : 0),
        (_, index) => ({
          id: uuidv4(),
          name: `Câu ${Number(index) + 1}:`,
          code: '',
          description: '',
          questionIndex: index,
          defaultQuestionType: QuestionType.ONE_CHOICE_QUESTION,
          defaultMark: 1,
          defaultWeight: 1,
          numberOfQuestions: 0,
          examTemplatePart: {
            id: examTemplatePart.id,
          },
          examTemplateQuestions: [],
        }),
      );

      examTemplateQuestionTemp.children = examTemplateQuestionsTemp;
    }

    dispatch(updateExamTemplateQuestionRequest(examTemplateQuestionTemp));
  };

  const onChangeTextAreaExamTemplatePart = (e: any, examTemplatePart: ExamTemplatePartRequest, fieldName: string) => {
    const examTemplatePartTemp = { ...examTemplatePart } as any;
    examTemplatePartTemp[fieldName] = e.target.value;

    dispatch(updateExamTemplatePartRequest(examTemplatePartTemp));
  };

  // const onChangeSelectExamTemplatePart = (e: any, examTemplatePart: ExamTemplatePartRequest, fieldName: string) => {
  //   const examTemplatePartTemp = { ...examTemplatePart } as any;
  //   examTemplatePartTemp[fieldName] = e;

  //   dispatch(updateExamTemplatePartRequest(examTemplatePartTemp));
  // };

  const onChangeSelectExamTemplateQuestion = (
    e: any,
    examTemplateQuestionRequest: ExamTemplateQuestionRequest,
    examTemplatePart: ExamTemplatePartRequest,
    fieldName: string,
  ) => {
    const examTemplateQuestionTemp = { ...examTemplateQuestionRequest } as any;
    examTemplateQuestionTemp[fieldName] = e;

    if (e !== QuestionType.GROUPED_QUESTION) {
      console.log(1111);
      examTemplateQuestionTemp.numberOfQuestions = 0;
      examTemplateQuestionTemp.children = null;
    }

    dispatch(updateExamTemplateQuestionRequest(examTemplateQuestionTemp));
  };

  const onChangeSelect = (e: any, fieldName: string) => {
    const examTemplateRequestTemp = { ...examTemplateRequest } as any;
    if (fieldName === 'schoolYear' || fieldName === 'subject') {
      examTemplateRequestTemp[fieldName] = {
        id: e,
      };
    }

    dispatch(updateExamTemplateRequest(examTemplateRequestTemp));
  };

  const addExamTemplatePart = (e: any) => {
    const newExamTemplatePart: ExamTemplatePartRequest = {
      id: uuidv4(),
      name: '',
      code: '',
      description: '',
      partIndex: examTemplateRequest?.examTemplateParts ? examTemplateRequest?.examTemplateParts.length : 0,
      numberOfQuestions: 0,
      children: [],
      examTemplateQuestions: [],
    };

    const examTemplateRequestTemp = { ...examTemplateRequest } as any;
    const examTemplatePartsTemp = [...examTemplateRequestTemp.examTemplateParts];
    examTemplatePartsTemp.push(newExamTemplatePart);
    examTemplateRequestTemp.examTemplateParts = examTemplatePartsTemp;

    dispatch(updateExamTemplateRequest(examTemplateRequestTemp));
  };

  const addChildExamTemplatePart = (e: any, parent: ExamTemplatePartRequest) => {
    const childExamTemplatePart: ExamTemplatePartRequest = {
      id: uuidv4(),
      name: '',
      code: '',
      description: '',
      partIndex: parent.children.length,
      numberOfQuestions: 0,
      children: [],
      examTemplateQuestions: [],
    };

    const parentTemp = { ...parent } as any;
    const examTemplatePartsTemp = [...parent.children];
    examTemplatePartsTemp.push(childExamTemplatePart);
    parentTemp.examTemplateParts = examTemplatePartsTemp;

    dispatch(updateExamTemplatePartRequest(parentTemp));
  };

  const deleteExamTemplatePart = (e: any, removeExamTemplatePart: ExamTemplatePartRequest) => {
    if (!examTemplateRequest?.examTemplateParts) {
      return;
    }

    let examTemplatePartsTemp = [...examTemplateRequest?.examTemplateParts];

    const removeNode = (array: ExamTemplatePartRequest[], removeItem: ExamTemplatePartRequest) => {
      const arrayEdit = [...array];
      if (arrayEdit.some((item) => item.id === removeItem.id))
        return arrayEdit.filter((item) => item.id !== removeItem.id);

      for (let i = 0; i < arrayEdit.length; i++) {
        arrayEdit[i] = { ...arrayEdit[i], children: removeNode(arrayEdit[i].children, removeItem) };
      }

      return arrayEdit;
    };

    examTemplatePartsTemp = removeNode(examTemplatePartsTemp, removeExamTemplatePart);

    const examTemplateRequestTemp = { ...examTemplateRequest, examTemplateParts: examTemplatePartsTemp };

    dispatch(updateExamTemplateRequest(examTemplateRequestTemp));
  };

  const getQuestionTypeDisplayName = (defaultQuestionType: QuestionType) => {
    switch (defaultQuestionType) {
      case QuestionType.GROUPED_QUESTION:
        return 'Nhóm câu hỏi.';
      case QuestionType.SHORT_QUESTION:
        return 'Câu hỏi trả lời ngắn.';
      case QuestionType.ONE_CHOICE_QUESTION:
        return 'Câu trắc nghiệm một đáp án.';
      case QuestionType.TOPIC_QUESTION:
        return 'Câu hỏi tự luận';
      case QuestionType.YES_NO_QUESTION:
        return 'Câu hỏi đúng sai.';
      default:
        return;
    }
  };

  const saveExamTemplate = async (e: any) => {
    try {
      const res = await axiosInstance({
        url: 'exam-templates',
        method: params.examTemplateId ? 'put' : 'post',
        data: examTemplateRequest,
      });

      if (res.status === 200) {
        message.success(params.examTemplateId ? 'Lưu thay đổi thành công.' : 'Thêm mẫu đề thi thành công.');
        navigate('/master-setting/test-template');
      } else {
        message.error('Có lỗi xảy ra');
      }
    } catch (err) {
      processError(err);
    }
  };

  useEffect(() => {
    calculateHeight();
  }, []);

  useEffect(() => {}, [examTemplateRequest]);

  return (
    <div className="w-full p-4 flex flex-col h-full gap-2 edit-exam-template">
      <div className="w-full bg-white rounded h-[60px] flex items-center justify-end gap-2 pr-2">
        <button className="px-2 py-1 bg-[#f1f1f1dd] rounded" onClick={(e) => cancelForm(e)}>
          Hủy
        </button>
        <button className="px-2 py-1 bg-[#e6f8ff] rounded hover:bg-[#c0ecfd]" onClick={(e) => saveExamTemplate(e)}>
          {params.examTemplateId ? 'Lưu' : 'Thêm mới'}
        </button>
      </div>
      <div className="w-full rounded preview-exam-template flex gap-2">
        <div className="flex-1 left-box hidden overflow-auto rounded bg-white relative">
          <div className="w-full bg-[#e6f8ff] text-center p-2 text-[18px] sticky top-0 z-10">Thông tin đề</div>
          <div className="flex gap-2 py-2 pl-4">
            <div className="w-[120px] text-left">Tên mẫu đề thi:</div>
            <Input
              type="text"
              name="name"
              value={examTemplateRequest?.name}
              className="w-[300px]"
              onInput={(e) => onInput(e, 'name')}
            />
          </div>
          <div className="flex gap-2 py-2 pl-4">
            <div className="w-[120px] text-left">Mã mẫu đề thi:</div>
            <Input
              type="text"
              name="name"
              value={examTemplateRequest?.code}
              className="w-[300px]"
              onInput={(e) => onInput(e, 'code')}
            />
          </div>
          <div className="flex gap-2 py-2 pl-4">
            <div className="w-[120px] text-left">Thời gian:</div>
            <Input
              type="number"
              name="name"
              value={examTemplateRequest?.defaultDuration}
              className="w-[100px]"
              onInput={(e) => onInput(e, 'defaultDuration')}
            />
            <div className="ml-2">giây</div>
          </div>
          <div className="flex gap-2 py-2 pl-4">
            <div className="w-[120px] text-left">Năm:</div>
            <Select
              onChange={(e) => onChangeSelect(e, 'schoolYear')}
              className="w-[300px]"
              value={examTemplateRequest?.schoolYear ? examTemplateRequest?.schoolYear.id : null}
              options={schoolYearList.map((schoolYear) => ({
                value: schoolYear.id,
                label: schoolYear.code,
              }))}
            />
          </div>
          <div className="flex gap-2 py-2 pl-4">
            <div className="w-[120px] text-left">Môn học:</div>
            <Select
              onChange={(e) => onChangeSelect(e, 'subject')}
              className="w-[300px]"
              value={examTemplateRequest?.subject ? examTemplateRequest?.subject.id : null}
              options={subjectList.map((subject) => ({
                value: subject.id,
                label: subject.name,
              }))}
            />
          </div>
          <div className="pl-4 flex items-center mt-4 justify-between pr-2">
            <div className="text-left text-[20px]">Cấu trúc đề thi:</div>
            <button
              className="rounded px-2 py-1 bg-[#e6f8ff] flex items-center hover:bg-[#c0ecfd]"
              onClick={(e) => addExamTemplatePart(e)}
            >
              <PlusOutlined />
              <div className="pl-2">Thêm phần thi</div>
            </button>
          </div>
          <div className="">
            <Tree
              option={{
                childMarginLeft: 'ml-6',
              }}
              startLevel={1}
              levelRender={10}
              dataTree={examTemplateRequest?.examTemplateParts ? examTemplateRequest?.examTemplateParts : []}
              fieldChildArray="examTemplateParts"
              showHideChildren={false}
              renderTreeItem={(treeItem: any) => {
                return (
                  <div className="w-full">
                    <div className="flex items-center gap-2 justify-between">
                      <div className="pl-4 flex items-center gap-2">
                        <MinusSquareOutlined className="w-[20px] h-[20px] text-[silver]" />
                        <div className="w-[120px]">Tên phần thi:</div>
                        <Input
                          className="w-fit"
                          value={treeItem.name}
                          onInput={(e) => onInputExamTemplatePart(e, treeItem, 'name')}
                        />
                      </div>
                      <div className="flex items-center gap-2 pr-2">
                        <button
                          className="rounded px-2 py-1 bg-[#e6f8ff] flex items-center hover:bg-[#c0ecfd]"
                          onClick={(e) => addChildExamTemplatePart(e, treeItem)}
                        >
                          <PlusOutlined />
                          <div className="pl-2">Thêm mục con</div>
                        </button>
                        <button
                          className="rounded p-1 bg-red-400 hover:bg-red-500"
                          onClick={(e) => deleteExamTemplatePart(e, treeItem)}
                        >
                          <DeleteOutlined />
                        </button>
                      </div>
                    </div>
                    <div className="mt-1 w-full p-4">
                      <div className="w-full">
                        <div className="w-[120px] text-left">Mô tả:</div>
                        <TextArea
                          value={treeItem.description}
                          onChange={(e) => onChangeTextAreaExamTemplatePart(e, treeItem, 'description')}
                          style={{ height: 60, resize: 'none' }}
                        />
                      </div>
                      <div className="w-full flex items-center mt-1">
                        <div className="w-[120px] text-left">Số câu hỏi:</div>
                        <Input
                          className="w-fit"
                          type="number"
                          value={treeItem.numberOfQuestions}
                          onInput={(e) => onInputExamTemplatePart(e, treeItem, 'numberOfQuestions')}
                        />
                      </div>
                      <div className="w-full mt-1">
                        <div className="text-left">Danh sách câu hỏi:</div>
                        <div>
                          <Tree
                            option={{
                              childMarginLeft: 'ml-6',
                            }}
                            startLevel={1}
                            levelRender={10}
                            dataTree={treeItem?.examTemplateQuestions ? treeItem?.examTemplateQuestions : []}
                            fieldChildArray="children"
                            showHideChildren={false}
                            renderTreeItem={(questionItem: any) => {
                              return (
                                <div>
                                  <div className="flex items-center gap-1">
                                    <LineOutlined className="w-[16px] h-[16px]" />
                                    <div className="w-full flex items-center mt-1">
                                      <div className="w-[120px] text-left">Tên câu hỏi:</div>
                                      <Input
                                        className="w-fit"
                                        maxLength={255}
                                        value={questionItem.name}
                                        onInput={(e) => onInputExamTemplateQuestion(e, questionItem, treeItem, 'name')}
                                      />
                                    </div>
                                  </div>
                                  <div className="ml-[20px]">
                                    <div
                                      className={
                                        'w-full flex items-center mt-1 ' +
                                        (questionItem.defaultQuestionType === QuestionType.GROUPED_QUESTION ||
                                        questionItem.defaultQuestionType === QuestionType.YES_NO_QUESTION
                                          ? 'hidden'
                                          : '')
                                      }
                                    >
                                      <div className="w-[120px] text-left">Điểm:</div>
                                      <Input
                                        className="w-fit"
                                        type="number"
                                        value={questionItem.defaultMark}
                                        onInput={(e) =>
                                          onInputExamTemplateQuestion(e, questionItem, treeItem, 'defaultMark')
                                        }
                                      />
                                    </div>
                                    <div
                                      className={
                                        'w-full flex items-center mt-1 ' +
                                        (questionItem.defaultQuestionType === QuestionType.GROUPED_QUESTION ||
                                        questionItem.defaultQuestionType === QuestionType.YES_NO_QUESTION
                                          ? 'hidden'
                                          : '')
                                      }
                                    >
                                      <div className="w-[120px] text-left">Trọng số:</div>
                                      <Input
                                        className="w-fit"
                                        type="number"
                                        value={questionItem.defaultWeight}
                                        onInput={(e) =>
                                          onInputExamTemplateQuestion(e, questionItem, treeItem, 'defaultWeight')
                                        }
                                      />
                                    </div>
                                    <div className="w-full flex items-center mt-1">
                                      <div className="w-[120px] text-left">Loại câu hỏi:</div>
                                      <Select
                                        onChange={(e) =>
                                          onChangeSelectExamTemplateQuestion(
                                            e,
                                            questionItem,
                                            treeItem,
                                            'defaultQuestionType',
                                          )
                                        }
                                        className="w-[300px]"
                                        value={questionItem.defaultQuestionType}
                                        options={questionTypes.map((ques) => ({
                                          value: ques.key,
                                          label: ques.value,
                                        }))}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'w-full flex items-center mt-1 ' +
                                        (questionItem.defaultQuestionType === QuestionType.GROUPED_QUESTION
                                          ? ''
                                          : 'hidden')
                                      }
                                    >
                                      <div className="w-[120px] text-left">Số câu hỏi con:</div>
                                      <Input
                                        className="w-fit"
                                        type="number"
                                        value={questionItem.numberOfQuestions}
                                        onInput={(e) =>
                                          onInputExamTemplateQuestion(e, questionItem, treeItem, 'numberOfQuestions')
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }}
            />
          </div>
        </div>
        <div className="flex-1 right-box hidden overflow-auto rounded bg-white relative">
          <div className="w-full bg-[#e6f8ff] text-center p-2 text-[18px] sticky top-0">Hiển thị</div>
          <div className="w-full pl-4">
            <Tree
              option={{
                childMarginLeft: 'ml-6',
              }}
              startLevel={1}
              levelRender={10}
              dataTree={examTemplateRequest?.examTemplateParts ? examTemplateRequest?.examTemplateParts : []}
              fieldChildArray="examTemplateParts"
              showHideChildren={false}
              renderTreeItem={(treeItem: any) => {
                return (
                  <div className="w-full">
                    <div className="flex items-start gap-1">
                      <MinusSquareOutlined className="w-[20px] h-[20px] text-[silver] pt-1" />
                      <div className="flex-1 text-left">
                        <b>{treeItem.name}</b>
                        {treeItem.description}
                      </div>
                    </div>
                    <div>
                      <Tree
                        option={{
                          childMarginLeft: 'ml-6',
                        }}
                        startLevel={1}
                        levelRender={10}
                        dataTree={treeItem?.examTemplateQuestions ? treeItem?.examTemplateQuestions : []}
                        fieldChildArray="children"
                        showHideChildren={false}
                        renderTreeItem={(questionItem: any) => {
                          return (
                            <div className="flex pl-7 items-center gap-2">
                              <div>
                                <b>{questionItem.name}</b>
                              </div>
                              <div
                                className={
                                  'flex items-center ' +
                                  (questionItem.defaultQuestionType === QuestionType.GROUPED_QUESTION ||
                                  questionItem.defaultQuestionType === QuestionType.YES_NO_QUESTION
                                    ? 'hidden'
                                    : '')
                                }
                              >
                                <div>Điểm:</div>
                                <div>{questionItem.defaultMark}</div>
                              </div>
                              <div
                                className={
                                  'flex items-center ' +
                                  (questionItem.defaultQuestionType === QuestionType.GROUPED_QUESTION ||
                                  questionItem.defaultQuestionType === QuestionType.YES_NO_QUESTION
                                    ? 'hidden'
                                    : '')
                                }
                              >
                                <div>Trọng số:</div>
                                <div>{questionItem.defaultWeight}</div>
                              </div>
                              <div className="flex items-center gap-1">
                                <div>Loại:</div>
                                <div>{getQuestionTypeDisplayName(questionItem.defaultQuestionType)}</div>
                              </div>
                            </div>
                          );
                        }}
                      />
                    </div>
                  </div>
                );
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
